import React from 'react';
import { styled } from '@mui/material/styles';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#F45B69',
        color: theme.palette.common.white,
        fontWeight: 700,
        border: `1px solid ${borderColor}`,
        verticalAlign: 'baseline',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        color: '#555555',
        border: `1px solid ${borderColor}`,
        verticalAlign: 'baseline',
    },
    '&.bold-text': {
        fontWeight: 700,
    },
    '&:first-child': {
        borderLeft: `1px solid ${specialBorderColor}`,
    },
    '&:last-child': {
        borderRight: `1px solid ${specialBorderColor}`,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: "#CCE5E5",
    },
}));

const ESevaTable1 = ({
    tableData
}) => {
    return (
        <>
            <TableContainer sx={{ width: "100%" }}>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell>Section No.</StyledTableCell>
                            <StyledTableCell>Section Title</StyledTableCell>
                            <StyledTableCell>Section Relevant Details</StyledTableCell>
                            <StyledTableCell>Design Considerations</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {
                            tableData && tableData.map((elem, index) => {
                                return (

                                    <StyledTableRow key={index}>
                                        <StyledTableCell>{elem.section_no}</StyledTableCell>
                                        <StyledTableCell>{elem.title}</StyledTableCell>
                                        <StyledTableCell>{elem.details}</StyledTableCell>
                                        <StyledTableCell>{elem.consideration}</StyledTableCell>
                                    </StyledTableRow>

                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}

export default ESevaTable1;
